"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Rocket = function Rocket() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "36",
    viewBox: "0 0 14 36"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B3DAF3",
    d: "M1.253 16.955v6.768l3.168-2.425v-6.769z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#287CB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75",
    d: "M4.42 21.298l-3.167 2.425v-6.768l3.168-2.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3DAF3",
    d: "M10.067 21.298l3.168 2.425v-6.769l-3.168-2.425z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#287CB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75",
    d: "M13.235 16.955l-3.168-2.426v6.769l3.168 2.425z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70B4E3",
    d: "M10.098 21.278c.55-1.12 1.741-6.54 1.741-9.072C11.84 5.823 7.231.252 7.231.252S2.622 5.823 2.622 12.206c0 2.532 1.19 7.952 1.742 9.072h5.734z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#287CB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75",
    d: "M10.098 21.278c.55-1.12 1.741-6.54 1.741-9.072C11.84 5.823 7.231.252 7.231.252S2.622 5.823 2.622 12.206c0 2.532 1.19 7.952 1.742 9.072h5.734z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M8.781 8.39a1.55 1.55 0 1 1-3.1 0 1.55 1.55 0 0 1 3.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#287CB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75",
    d: "M8.781 8.39a1.55 1.55 0 1 1-3.1 0 1.55 1.55 0 0 1 3.1 0zM7.231 17.354v6.769M4.42 26.404v6.056M9.939 26.404v6.056M7.111 27.461v8.028"
  })));
};
var _default = Rocket;
exports["default"] = _default;